import { faDiagramProject, faExpand } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function List({ list, editHandler }) {

    return (
        <>
            {list.map((item) => (
                <div key={item.ID} className="row list_item mt-15 param_row" onClick={() => { editHandler(item) }}>
                    <div className="col-lg-3 d-flex align-items-center">
                        <div className='task_list_name p-1' >
                            <div className="badge_item" style={{ backgroundColor: item.Color }}>{item.Name}</div>
                        </div>
                    </div>
                    <div className="col-lg-3 d-flex align-items-center justify-content-lg-center">
                        <i className="mr-5"><FontAwesomeIcon icon={faExpand} /></i>
                        {item.All_Object === true ? "Все объекты" : "Некоторые объекты"}
                    </div>
                    <div className="col-lg-3 d-flex align-items-center justify-content-lg-center">
                        <i className="mr-5"><FontAwesomeIcon icon={faDiagramProject} /></i>
                        {item.All_Project === true ? "Все проекты" : "Некоторые проекты"}
                    </div>
                </div>
            ))}
        </>)
}

export default List;